import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import { initialize } from '../initialize';

import type { SignUpInput } from '@/infra/cognitoIApi';
import type { ThunkApiType } from '@/store';

import { uiSlice } from '@/domain/ui/redux';
import { userSlice } from '@/domain/user/redux';
import { service } from '@/share';

/**
 * Init
 */
export const init = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'user/init',
  async (_, thunkApi) => {
    try {
      // usernameを取得
      await initialize(thunkApi.dispatch);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(error);
      // 取得できない場合はログインを求める
      thunkApi.dispatch(userSlice.actions.setMode('signin'));
      thunkApi.dispatch(userSlice.actions.setUser(undefined));
    }
  },
);

/**
 * ログイン
 */
export const signIn = createAsyncThunk<
  void,
  {
    /** ユーザー名 */
    username: string;
    /** パスワード */
    password: string;
  },
  ThunkApiType
>(
  'user/signIn',
  async (signInInput, thunkApi) => {
    const { username, password } = signInInput;
    const { status, msg } = await service.user.signIn(username, password);
    if (status === 'ok') {
      await initialize(thunkApi.dispatch);
      thunkApi.dispatch(uiSlice.actions.setMessage({
        key: 'info',
        content: msg,
      }));
      return;
    }
    // error
    thunkApi.dispatch(uiSlice.actions.setMessage({
      key: 'error',
      content: msg,
    }));
    if (status === 'confirm') {
      thunkApi.dispatch(userSlice.actions.setMode('confirmsignup'));
      thunkApi.dispatch(userSlice.actions.setUser({
        name: signInInput.username,
        attributes: undefined,
      }));
    }
  },
);

export const signUp = createAsyncThunk<
  void,
  SignUpInput
>(
  'auth/signUp',
  async (input, thunkApi) => {
    const { status, msg } = await service.user.signUp(input);
    if (status === 'ok') {
      thunkApi.dispatch(uiSlice.actions.setMessage({
        key: 'info',
        content: msg,
      }));
      thunkApi.dispatch(userSlice.actions.setUser({
        name: input.userId,
        attributes: undefined,
      }));
      thunkApi.dispatch(userSlice.actions.setMode('confirmsignup'));
    } else {
      thunkApi.dispatch(uiSlice.actions.setMessage({
        key: 'error',
        content: msg,
      }));
    }
  },
);

export const resendSignUp = createAsyncThunk<void, string, ThunkApiType>(
  'auth/resendSignUp',
  async (username, thunkApi) => {
    const { status, msg } = await service.user.resendSignUp(username);
    if (status === 'ok') {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'info', content: msg }));
    } else {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'error', content: msg }));
    }
  },
);

export const signUpConfirm = createAsyncThunk<
  void,
  {
    /** ユーザー名 */
    username: string;
    /** コード */
    code: string;
  }
>(
  'auth/signUpConfirm',
  async (input, thunkApi) => {
    const { status, msg } = await service.user.confirmSignUp(input.username, input.code);
    if (status === 'ok') {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'info', content: msg }));
      thunkApi.dispatch(userSlice.actions.setMode('signin'));
    } else {
      thunkApi.dispatch(uiSlice.actions.setMessage({ key: 'error', content: msg }));
    }
  },
);
